@if (insuredObjects && insuredObjectsConfig) {
    <div class="clearfix"></div>
    @for (insuredObject of insuredObjects; track insuredObject; let $i = $index) {
        <div [ngClass]="{ 'm-12:t md:m-16:t lg:m-24:t': $i > 0 }">
            @if (insuredObjects.length > 1) {
                <small>
                    <strong>{{ $i + 1 }}. {{ insuredObjectsConfig.objectDescriptionSingular }}</strong>
                </small>
            }
            <dl class="clearfix">
                @for (control of insuredObjectsConfig.controls; track control) {
                    <dt>{{ control.label }}</dt>
                    @if (control.type !== 'value' && control.type !== 'select') {
                        <dd>
                            {{ insuredObject[control.name] || 'keine Angabe' }}
                        </dd>
                    }
                    @if (control.type === 'value') {
                        <dd>
                            {{ insuredObject[control.name] | commaToDot | currency: 'EUR' : 'symbol' : '1.2-2' }}
                        </dd>
                    }
                    @if (control.type === 'select') {
                        <dd>
                            {{ getOptionDescription(control.name, insuredObject[control.name]) }}
                        </dd>
                    }
                }
            </dl>
        </div>
    }
}
